// Validation Quantity field in Menu Projection
export const validateQuantity = (value: string, type: string | undefined): boolean => {
    if (type === "Kg" || type === "gms") {
        // Allow only numbers with up to 3 decimal points
        return /^\d*\.?\d{0,3}$/.test(value);
    } else if (type === "Pc" || type === "Pcs" || type === "Pax") {
        // Allow only integers
        return /^\d*$/.test(value);
    }
    return false;
};